(ns manatee.qa.styles
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem px]]))

(def report-form-styles
  [:.qa-report-form__actions
   {:display :flex}
   [:button:first-child
    {:margin-right (rem 0.5)}]
   [:button:last-child
    {:margin-left (rem 0.5)}]])

(def qa-feedback-form-styles
  [[:.qa-feedback-form
    [:textarea
     {:width "100%"
      :height (rem 15)}]]
   [:.qa-feedback-form__actions
    {:display :flex
     :margin-top (rem 0.5)}
    [:button {:margin (rem 0.5)}]
    [:button:first-child
     {:margin-left 0}]
    [:button:last-child
     {:margin-right 0}]]])

(def qa-view-styles
  [:.qa-view-container {:min-width "100%"}
   [:.part-answers {:padding-bottom (rem 1)}]
   [:.action-buttons {:margin-top (rem 1)
                      :display "flex"}
    [:.rothko-btn {:margin (rem 0.5)}]]
   [:.qa-view-details
    [:.panel {:flex "1 1 auto"
              :min-width "min-content"
              :max-width "70%"}]]
   [:.feedback__comment
    {:padding [[(rem 2) 0]]}
    [:&.no-report
     {:padding [[0 0 (rem 1) 0]]}]]
   [:.feedback__warning
    {:display :none}]
   [:.qa-loading
    {:display :flex
     :justify-content :center
     :align-items :center
     :min-height (rem 60)}]])

(def compare-styles
  [:body
   [:.qa-compare-options
    {:justify-content :center
     :gap (rem 2)
     :padding-top (rem 0.5)
     :padding-bottom (rem 2)}]
   [:table.qa-compare-table
    {:min-width "100%"}]
   [:.qa-compare-view
    [:.answer-panel
     {:width "50%"}]
    [:.panel {:flex "1 1 auto"}]
    [:.editor__document {:max-height (px 500)}]
    [:.button-wrapper
     {:float :left
      :margin-right (px 10)}]]
   [:.layout.compare-item-edits-page
    {:grid-template-columns "auto 100% auto"}
    [:.panel {:max-width :inherit}]]])

(defn main
  []
  [report-form-styles
   qa-feedback-form-styles
   qa-view-styles
   compare-styles])
